import { Text, useBreakpointValue, VStack } from "@chakra-ui/react"
import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import PackageTag from "@pathwright/features/src/modules/package/PackageTag"

const ActivateButton = (props) => {
  props = {
    fromUrl: null,
    utmSource: "",
    prompt: "Activate Now",
    className: "ActivateButton",
    styleType: "link",
    ...props
  }

  const isMobile = useBreakpointValue({ base: true, lg: false })

  let activateLocation = {
    pathname: "/pricing/",
    query: {}
  }

  if (props.fromUrl) {
    activateLocation.query.from = props.fromUrl
  }

  if (props.utmSource) {
    activateLocation.query.utm_source = props.utmSource
  }

  return (
    <VStack w="100%" gap={2}>
      <Button {...props} to={activateLocation}>
        {props.children ? (
          props.children
        ) : (
          <span>
            {props.prompt} <Pathicon icon="chevron-right" />
          </span>
        )}
      </Button>
      <PackageTag
        positioning={{
          placement: isMobile ? "bottom" : "right",
          gutter: 8,
          shift: 12,
          overflowPadding: 12,
          slide: true
        }}
        dataSource="assignment"
        renderWithTag={(tagRender, packageData) =>
          packageData?.coupon_discount ? (
            <VStack w="100%" align="center" gap={1}>
              <Text fontSize="sm" color="gray.600" m={0}>
                Get {packageData.coupon_discount}% off with
              </Text>
              {tagRender}
            </VStack>
          ) : null
        }
      />
    </VStack>
  )
}

ActivateButton.displayName = "ActivateButton"
export default ActivateButton
